import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Dashboard {
  private readonly http = inject(HttpClient);

  messageStats(filters: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.message.statistics}`, {
      params: filters
    });
  }
}
